import { render } from "./Table.vue?vue&type=template&id=3e088f4a&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import "./Table.vue?vue&type=style&index=0&id=3e088f4a&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e088f4a"]])

export default __exports__